export enum ProdutosEnum {
  ID_VELES = 1,
  IA_VELES = 3,
  DASH_VELES = 5,
  GEO_VELES = 6,
  AUTO_VELES = 9,
  AUTH_VELES = 13
}

export const LegacyProductsList = [
  ProdutosEnum.ID_VELES,
  ProdutosEnum.IA_VELES,
  ProdutosEnum.DASH_VELES,
  ProdutosEnum.GEO_VELES,
  ProdutosEnum.AUTO_VELES,
  ProdutosEnum.AUTH_VELES,
];
